import type { UpgradeEffect } from './types';

/** A golden-nugget reward kind, chosen by weight when one spawns. */
export interface NuggetDef {
  id: string;
  name: string;
  icon: string;
  weight: number;
  kind: 'cash' | 'buff' | 'ore';
  /** For 'buff': the timed effect + duration (seconds). */
  effect?: UpgradeEffect;
  duration?: number;
}

export const NUGGET_REWARDS: readonly NuggetDef[] = [
  { id: 'cash', name: 'Glückstreffer', icon: '💰', weight: 4, kind: 'cash' },
  { id: 'lode', name: 'Reiche Tasche', icon: '⛏️', weight: 3, kind: 'ore' },
  { id: 'frenzy', name: 'Klick-Rausch', icon: '🤜', weight: 2, kind: 'buff', effect: { type: 'clickMult', value: 6 }, duration: 18 },
  { id: 'rush', name: 'Goldrausch', icon: '🌟', weight: 2, kind: 'buff', effect: { type: 'autoMult', value: 4 }, duration: 25 },
] as const;

export const NUGGET_BY_ID: Record<string, NuggetDef> = Object.fromEntries(
  NUGGET_REWARDS.map((n) => [n.id, n]),
);
